<template>
	<div class="login-container">
		<div class="loginTop">
			<el-image style=" height: 30px" :src="url" fit="fit"></el-image>
			<Lang />
		</div>
		<el-form ref="loginForm" :model="loginForm" :rules="loginRules" class="login-form">
			<div class="title-container">
				<h3 class="title">{{ $t('注册并使用免费版') }}</h3>
				<p class="sub-title">{{ $t('已有账号') }}?
					<router-link to="/" style="text-decoration: none; color: #4663ed;">
						{{ $t('立即登录') }}
					</router-link>
				</p>
			</div>
			<el-form-item prop="username">
				<el-input v-model="loginForm.username" :placeholder="$t('请输入账号')" type="text" />
			</el-form-item>

			<el-form-item prop="password">
				<el-input v-model="loginForm.password" :placeholder="$t('请输入密码')" show-password />
			</el-form-item>

			<el-form-item prop="code">
				<el-input v-model="loginForm.code" :placeholder="$t('请输入邀请码')" />
			</el-form-item>

			<div class="aux-handler">
				<el-checkbox v-model="loginForm.remember">{{ $t('我已阅读并同意') }}</el-checkbox>
				<span style="color: #3e52ff;">
					{{ $t('服务协议') }}、
				</span>
				<span style="color: #3e52ff;">
					{{ $t('隐私政策') }}
				</span>
				<span>{{ $t('和') }}</span>
				<span style="color: #3e52ff;">
					{{ $t('用户行为规范') }}
				</span>
			</div>
			<el-button type="primary" class="login-btn" @click="handleLogin">{{ $t('创建免费账号') }}</el-button>
		</el-form>


	</div>
</template>

<script>
import Lang from '../../common/Lang.vue';
export default {
	components: {
		Lang
	},

	data() {
		return {
			url: require('../../assets/image/logo.png'),
			loginForm: {
				username: '',
				password: '',
				remember: true,
				code: ''
			},
		}
	},
	computed: {
		loginRules() {
			return {
				username: [{ required: true, trigger: 'blur', message: this.$t('请输入账号') }],
				password: [{ required: true, trigger: 'blur', message: this.$t('请输入密码') }],
				code: [{ required: true, trigger: 'blur', message: this.$t('请输入邀请码') }]
			};
		}
	},
	methods: {
		handleLogin() {
			if (!this.loginForm.remember) {
				this.$message.warning('请勾选协议')
				return
			}
			this.$axios.post(this.$apis.register, {
				username: this.loginForm.username,
				password: this.loginForm.password,
				invite_code: this.loginForm.code
			}).then(res => {
				if (res.code == 1) {
					console.log(res.data);
					this.$store.commit('setUserInfo', res.data.info)
					this.$store.commit('setToken', res.data.info.token)
					this.$message.success(res.msg)
					// 延时跳转，让用户看到提示
					setTimeout(() => {
						this.$nav.go('/home/home');
					}, 800)
				}
			})
		}
	}
}
</script>

<style lang="scss" scoped>
/* 使用你之前提到的 SCSS 变量 */
$bg: #fff;
$primary_blue: #3e52ff;

.login-container {
	min-height: 100vh;
	width: 100%;
	display: flex;
	justify-content: center;
	align-items: center;
	position: relative;
	background: linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%); // 增加渐变底色

	.loginTop {
		width: 100%;
		position: absolute;
		top: 0px;
		display: flex;
		justify-content: space-between;
		align-items: center;
		padding: 20px;

	}

	.login-form {
		width: 520px;
		background-color: #fff;
		padding: 40px;
		border-radius: 16px;
		box-shadow: 0 10px 25px rgba(0, 0, 0, 0.05); // 增加阴影让表单更立体

		.title-container {
			text-align: center;
			margin-bottom: 40px;
			color: #000;

			.logo {
				width: 120px;
				margin-bottom: 30px;
			}

			.title {
				font-size: 30px;
			}

			.sub-title {
				font-size: 16px;
				padding: 24px 0;
			}
		}

		::v-deep .el-form-item {
			margin-bottom: 30px;
		}

		/* 深度修改 Element 输入框样式以符合图片 */
		::v-deep .el-input__inner {
			height: 48px;
			line-height: 48px;
			border-radius: 8px;
			border: 1px solid #dee0e3;


		}

		.aux-handler {
			display: flex;
			justify-content: space-between;
			margin: 30px 0;

			span {
				font-size: 13px;
				cursor: pointer;
			}
		}

		.login-btn {
			width: 100%;
			height: 48px;
			font-size: 16px;
			background-color: $primary_blue;
			border-color: $primary_blue;
			border-radius: 24px;
			/* 圆角按钮 */
		}
	}
}
</style>